import { render, staticRenderFns } from "./Startseite.vue?vue&type=template&id=11c5c6be&scoped=true&"
import script from "./Startseite.vue?vue&type=script&lang=js&"
export * from "./Startseite.vue?vue&type=script&lang=js&"
import style0 from "./Startseite.vue?vue&type=style&index=0&id=11c5c6be&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5c6be",
  null
  
)

export default component.exports